import Vue from 'vue'
import VueRouter from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import Dinamica from '../views/Dinamica.vue'
import Resultado from '../views/Resultado.vue'
import MiCuenta from '../views/MiCuenta.vue'
import Participaciones from '../views/Participaciones.vue'
import Terminos from '../views/Terminos.vue'
import LoginReportes from '../views/LoginReportes.vue'


import { auth } from '../firebase'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    {
        path: '/dinamica',
        name: 'Dinamica',
        component: Dinamica,
        meta: {
            requiresAuth: true,
            requiresTicket: true
        }
    },
    {
        path: '/resultado',
        name: 'Resultado',
        component: Resultado,
        meta: {
            requiresAuth: true
        }
    },
    // {
    //     path: '/mi-cuenta',
    //     name: 'Mi Cuenta',
    //     component: MiCuenta,
    //     meta: {
    //         requiresAuth: true
    //     }
    // },
    {
        path: '/mis-participaciones',
        name: 'Participaciones',
        component: Participaciones,
        meta: {
            requiresAuth: true,
            requiresNoTicket: true
        }
    },
    {
        path: '/',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Login.vue')
    },
    {
        path: '/mecanica',
        name: 'Mecanica',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Mecanica.vue')
    },
    {
        path: '/verificacion/:id/:codigo',
        name: 'Verificacion',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Verificacion.vue')
    },
    {
        path: '/ganadores',
        name: 'Ganadores',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/Ganadores.vue')
    },
    // {
    //     path: '/premios',
    //     name: 'Premios',
    //     component: () =>
    //         import ( /* webpackChunkName: "login" */ '../views/Premios.vue')
    // },
    {
        path: '/reportes',
        name: 'Reportes',
        component: LoginReportes,
    },
    {
        path: '/reportes/informe',
        name: 'Informe',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesInforme.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    },
    {
        path: '/reportes/descarga',
        name: 'InformeDescarga',
        component: () =>
            import ( /* webpackChunkName: "login" */ '../views/ReportesDescarga.vue'),
        meta: {
            requiresAuthAdmin: true
        }
    },

    {
        path: '/terminos-y-condiciones',
        name: 'terminos',
        component: Terminos
    }
]

const router = new VueRouter({
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    base: process.env.BASE_URL,
    routes
})

// navigation guard to check for logged in users
router.beforeEach((to, from, next) => {
    const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
    const requiresAuthAdmin = to.matched.some(x => x.meta.requiresAuthAdmin)

    const requiresNoTicket = to.matched.some(x => x.meta.requiresNoTicket)
    const requiresTicket = to.matched.some(x => x.meta.requiresTicket)

    if (requiresAuthAdmin === true && auth.currentUser != null && auth.currentUser.uid === 'fkU2EAWkCEhwQ4i312qnUthQMMB2') {
        next()
    } else if (requiresAuthAdmin === true) {
        next('/login')
    } else if (requiresAuth && !auth.currentUser) {
        next('/login')
    } else {

        if (auth.currentUser != null && auth.currentUser.uid === 'fkU2EAWkCEhwQ4i312qnUthQMMB2' && from.path != '/reportes/informe') {
            next('/reportes/informe')
        }

        // // // if (requiresNoTicket === true) {
        // // //     if (localStorage.getItem('id_ultimo_ticket_veranocinepolis23') != null && localStorage.getItem('id_ultimo_ticket_veranocinepolis23') != '') {
        // // //         next('/dinamica')
        // // //         return
        // // //     }
        // // // } else if (requiresTicket === true) {
        // // //     if (localStorage.getItem('id_ultimo_ticket_veranocinepolis23') == null || localStorage.getItem('id_ultimo_ticket_veranocinepolis23') == '') {
        // // //         next('/')
        // // //         return
        // // //     }
        // // // }

        next()

    }
})

export default router